import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    setZeroMessageCountSync,
    incrementRefusalCountSync, 
    incrementMessageCapSync, 
    toggleIsMinimizedSync,
    setOnMoveStageSync,
    checkListItemSync,
} from '../../slices/chatThunk';
import { 
    selectCurrChatStage, 
    selectCurrChatIsMinimized,
    selectCurrChatChecklist,
 } from '../../slices/currChatSlice';
import { Accordion } from 'flowbite-react';
import { getSummary, recenterConversation } from '../../slices/openAiThunk'
import Draggable from 'react-draggable'

export default function MoveStagePopUp({ advanceStage }) {
    const dispatch = useDispatch();
    const currChatStage = useSelector(selectCurrChatStage)
    const currChatIsMinimized = useSelector(selectCurrChatIsMinimized)
    const currChatCheckList = useSelector(selectCurrChatChecklist(currChatStage))

    const [initialPosistion, setInitialPosition] = useState(null)
    const [position, setPosition] = useState({ x: 0, y: 0 })
    const [summary, setSummary] = useState('');
    const [summaryReady, setSummaryReady] = useState(false)

    const toggleMinimize = () => {
        dispatch(toggleIsMinimizedSync())
    };

    const onDragStart = (e, data) => {
        setInitialPosition({ x: data.x, y: data.y })
    }

    const onDragEnd = (e, data) => {
        const distanceMoved = Math.sqrt(Math.pow(initialPosistion.x - data.x, 2) + Math.pow(initialPosistion.y - data.y, 2));
        const clickThreshold = 1;
        if (distanceMoved < clickThreshold) {
            dispatch(toggleIsMinimizedSync())
        } 
        setPosition({ x: data.x, y: data.y });
    }

    useEffect(() => {
        const fetchSummary = async () => {
            try {
                const summary = await dispatch(getSummary());
                setSummary(summary.payload);
                setSummaryReady(true)
            } catch (err) {
                console.error("Failed to fetch summary:", err);
            }
        };
    
        fetchSummary();
    }, [])

    return (
        <div>
            {!currChatIsMinimized ?
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="absolute inset-0 bg-black opacity-60"></div>

                    <div className="relative bg-[#333333] p-6 rounded-lg shadow-lg max-w-md w-full text-white space-y-4">
                        <button 
                            onClick={toggleMinimize} 
                            className="absolute top-1.5 left-1 text-white bg-[#1993D6] rounded-full p-0.5 text-sm md:text-lg w-5 h-5 flex items-center justify-center opacity-75"
                        >
                            −
                        </button>

                        {/* Question Section */}
                        <p className="text-left font-calibri text-lg">
                        We've had a substantial conversation in the {currChatStage} stage.
                        </p>
                        
                        <Accordion className="my-4 bg-[#2c2c2c] rounded-md divide-gray-700 border-gray-700" flush={true}>
                            <Accordion.Panel>
                                <Accordion.Title className="bg-gray-800 text-white">
                                    Summary
                                </Accordion.Title>

                                <Accordion.Content className='bg-gray-900'>
                                { summaryReady ? <p>{summary}</p> : <p>Loading Summary ...</p>}
                                </Accordion.Content>
                            </Accordion.Panel>

                            <Accordion.Panel>
                                <Accordion.Title className="bg-gray-800 text-white">
                                    Goal Checklist
                                </Accordion.Title>

                                <Accordion.Content className='bg-gray-900'>
                                    <div className="space-y-2">
                                        {currChatCheckList.map((item) => (
                                            <div key={item.id} className="grid grid-cols-[auto,1fr] items-center gap-2 mb-2">
                                                <input 
                                                    id={`checkbox-${item.id}`}
                                                    type="checkbox" 
                                                    checked={item.checked} 
                                                    onChange={() => dispatch(checkListItemSync(item.id))} 
                                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                                                />
                                                <label htmlFor={`checkbox-${item.id}`} className="text-base font-medium text-white">{item.text}</label>
                                            </div>
                                        ))}
                                    </div>
                                </Accordion.Content>
                            </Accordion.Panel>
                        </Accordion>

                        {/* Buttons Section */}
                        <div className="flex justify-between space-x-2">
                            <button 
                                onClick={() => {
                                    dispatch(setZeroMessageCountSync());
                                    advanceStage();
                                    dispatch(setOnMoveStageSync(false));
                                }}
                                className="px-4 py-2 bg-[#1e1e1e] text-white border border-white rounded-lg hover:bg-[#444] focus:outline-none focus:border-[#555] whitespace-nowrap w-1/2 max-w-xs"
                            >
                                Next Stage
                            </button>
                            <button 
                                onClick={() => {
                                    dispatch(incrementRefusalCountSync());
                                    dispatch(incrementMessageCapSync());
                                    dispatch(recenterConversation(currChatCheckList.filter(item => !item.checked)));
                                    dispatch(setOnMoveStageSync(false));
                                    
                                }}
                                className="px-4 py-2 bg-[#1e1e1e] text-white border border-white rounded-lg hover:bg-[#444] focus:outline-none focus:border-[#555] whitespace-nowrap w-1/2 max-w-xs"
                            >
                                Stay and Explore
                            </button>
                        </div>
                    </div>
                </div>
            : 
                <Draggable position={position} onStart={onDragStart} onStop={onDragEnd}>
                    <div className="fixed top-20 left-50 z-50">
                        <div className="animate-bounce fixed top-20 left-50 z-50 p-2 rounded-full bg-[#1993D6] text-white opacity-75 cursor-pointer flex items-center justify-center w-12 h-12">
                            +
                        </div>
                    </div>
                </Draggable>
        } 
        </div>
    );
}
